import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getToken, hasRole, isTokenExpired, Role } from '../auth';

interface Props {
    roles?: Role[];
}

const ProtectedRoute: React.FC<Props> = ({ roles }) => {
    if (!getToken() || isTokenExpired()) {
        return <Navigate to="/login" />;
    }
    if (roles && roles.length > 0 && !roles.some(hasRole)) {
        return <Navigate to="/" />;
    }
    return <Outlet />;
};

export default ProtectedRoute;
